export default {
  // errorMessage code : i18n constant
  EMAIL_ALREADY_EXISTS: 'SUBSCRIBE_EMAIL_EXISTS'
}
